import React from "react";
import { useTheme } from "styled-components/macro";

type Ref = React.ForwardedRef<SVGSVGElement> | null;

type DefaultProps = {
  width?: number | string;
  height?: number | string;
};

type Props = React.SVGProps<SVGSVGElement> & DefaultProps;
type LogoSVGProps = Props & {
  svgRef?: Ref;
};

const defaultProps: DefaultProps = {
  width: "100%",
  height: "100%",
};

function LogoSVG({ width, height, svgRef, ...props }: LogoSVGProps) {
  const { colors } = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox="20 0 200 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M24.7 48.47H19v-1.766c-1.9 1.454-4.4 2.285-7.2 2.285C5.3 48.989 0 43.38 0 36.216c0-7.062 5.3-12.773 11.8-12.773 2.8 0 5.3.83 7.2 2.284V11.813h5.7V48.47zm-5.7-8.1v-8.308c-1.6-2.492-3.9-3.427-6.4-3.427-4 0-7 3.53-7 7.58 0 4.05 2.9 7.685 7 7.685 2.5 0 4.8-.934 6.4-3.53zM52.7 37.878H34.5c.5 3.427 2.8 6.127 7.1 6.127 2.3 0 3.9-.727 4.8-2.285h6.1c-1.3 4.465-5.7 7.58-11 7.58C34 49.3 29 43.59 29 36.32c0-7.477 5-12.98 12.4-12.98 6.7 0 11.6 5.088 11.6 12.565-.1.83-.2 1.35-.3 1.973zm-18.1-3.739H47c-.4-3.634-2.5-5.815-5.8-5.815-3.8 0-6 2.493-6.6 5.815zM60.6 40.266c.5 2.908 2.6 4.154 5.8 4.154 2.8 0 4.7-1.038 4.7-2.7 0-1.246-1-2.18-2.8-2.596l-5.1-.83c-3.6-.624-7-2.597-7-7.062 0-4.88 4-7.892 9.9-7.892 4 0 9.8 1.454 10.4 8.1h-5.3c-.3-2.389-2.4-3.427-5.1-3.427-2.8 0-4.2 1.142-4.2 2.596 0 1.142.8 2.284 3.3 2.804l4.4.726c3.6.624 7 2.285 7 7.062 0 5.192-4.4 8.1-10.3 8.1-5.4 0-10.3-2.285-10.9-9.035h5.2zM86.8 42.965v5.504h-5.7V11.812h5.7v23.365l10.3-11.111h7.3L95 34.139l10.8 14.33h-7.5L91 38.5l-4.2 4.465zM133.101 36.32c0 7.061-5.3 12.773-11.8 12.773-2.8 0-5.3-.831-7.2-2.285v13.915h-5.8V24.066h5.8v1.662c1.9-1.454 4.3-2.285 7.2-2.285 6.5.104 11.8 5.712 11.8 12.877zm-5.7 0c0-4.05-2.9-7.684-7-7.684-2.4 0-4.7.934-6.3 3.426v8.412c1.6 2.492 3.9 3.427 6.3 3.427 4.1 0 7-3.531 7-7.581zM160.8 24.066V48.47H155v-1.661c-1.9 1.454-4.4 2.284-7.2 2.284-6.6 0-11.8-5.711-11.8-12.772 0-7.166 5.3-12.773 11.8-12.773 2.8 0 5.3.83 7.2 2.284V24.17h5.8v-.104zM155 40.37v-8.308c-1.6-2.492-3.9-3.427-6.4-3.427-4 0-7 3.53-7 7.685 0 4.05 2.9 7.58 7 7.58 2.5 0 4.8-.934 6.4-3.53zM169.899 40.266c.5 2.908 2.6 4.154 5.8 4.154 2.8 0 4.7-1.038 4.7-2.7 0-1.246-1-2.18-2.8-2.596l-5.1-.83c-3.6-.624-7-2.597-7-7.062 0-4.88 4-7.892 9.9-7.892 4 0 9.8 1.454 10.4 8.1h-5.3c-.2-2.493-2.4-3.531-5.1-3.531-2.8 0-4.2 1.142-4.2 2.596 0 1.142.8 2.285 3.3 2.804l4.4.727c3.6.623 7 2.284 7 7.061 0 5.192-4.4 8.1-10.3 8.1-5.4 0-10.3-2.285-10.9-9.035l5.2.104zM193.8 40.266c.5 2.908 2.6 4.154 5.8 4.154 2.8 0 4.7-1.038 4.7-2.7 0-1.246-1-2.18-2.8-2.596l-5.1-.83c-3.6-.624-7-2.597-7-7.062 0-4.88 4-7.892 9.9-7.892 4 0 9.8 1.454 10.4 8.1h-5.3c-.2-2.493-2.4-3.531-5.1-3.531-2.8 0-4.2 1.142-4.2 2.596 0 1.142.8 2.285 3.3 2.804l4.4.727c3.6.623 7 2.284 7 7.061 0 5.192-4.4 8.1-10.3 8.1-5.4 0-10.3-2.285-10.9-9.035l5.2.104z"
        fill={colors.accent}
      />
      <path d="M86.787 5.92V0h-67.8v5.92h67.8z" fill={colors.primary} />
    </svg>
  );
}

LogoSVG.defaultProps = defaultProps;

const ForwardRef = React.forwardRef((props: Props, ref: Ref) => (
  <LogoSVG {...props} svgRef={ref} />
));

export default ForwardRef;
